<template>
    <div class="h-100 d-flex flex-column justify-content-center pt-5" style="width: 40%;">
        <div class="d-flex flex-column justify-content-between">
            <h2 class="text-dark-blue" v-if="name !== ''">{{name}}</h2>
            <h2 class="text-dark-blue" v-else>Enter course name</h2>
            <input v-if="editEnabled" type="text" name="course-title" autocomplete="off" id="course-name-input" v-on:change="clearWarning($event)" v-model="name" placeholder="Course Name" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CourseNameHeader',
        props: ["courseName", "edit"],
        data: function () {
            return {
                name: this.courseName,
                editEnabled: this.edit,
            };
        },
        watch: {
            edit: function(newVal, oldVal){
                this.editEnabled = newVal;
            },
            name: function(newVal, oldVal){
                this.$emit("handleNameChanged", newVal);
            }
        },
        methods: {
            clearWarning(event) {
                $(event.target).removeClass("bdRed");
            }
        },
        mounted: function () {
            //console.log("Name header loaded", this.name, this.editEnabled);
        },
    }
</script>

<style scoped>
    h2{
        font-size: 50px;
    }

    .course-name-input:focus{
        border: none!important;
    }
</style>
